import { render } from "./protocol_add_user.vue?vue&type=template&id=152051b4"
import script from "./protocol_add_user.vue?vue&type=script&lang=js"
export * from "./protocol_add_user.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocol/inside/add_user/protocol_add_user.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "152051b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('152051b4', __exports__)) {
    console.log('reload')
    api.reload('152051b4', __exports__)
  }
  
  module.hot.accept("./protocol_add_user.vue?vue&type=template&id=152051b4", () => {
    console.log('re-render')
    api.rerender('152051b4', render)
  })

}


export default __exports__